module.exports = __webpack_public_path__ + "static/media/24_B.149f62da.png";